import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { PageLoader } from '../../../../shared_elements';
import { Tooltip } from '@material-ui/core';
import { globalGetService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import EditSecurityCurrencyCard from './SecurityCurrencyCardEdit';
export default function SecurityCurrencyCard({ props, getResponseBack }) {
    const [editModal, setEditModal] = useState({ modal: false });
    const [securityCurrencycard, setSecurityCurrencycard] = useState({});
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getSecurityCurrencycard();
    }, [])
    const toggleEditSideBar = (data) => {
        setEditModal({ modal: true, data: securityCurrencycard })
    }
    const getSecurityCurrencycard = () => {
        setLoading(true);
        globalGetService(`/contracts/contract-details/${props.params.contract_slug}/`)
            .then((response) => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    setSecurityCurrencycard(response?.data.data);
                } else {
                    toastFlashMessage(response?.data.message, 'error');
                }
            })
    }
    const updateSecurityCurrencycard = (data, type, assetViewId) => {
        setLoading(true);
        globalPutService(`contracts/contract-details/${props.params.contract_slug}/`, data)
            .then(response => {
                if (checkApiStatus(response)) {
                    setEditModal({ modal: false });
                    getSecurityCurrencycard();
                    setLoading(false);
                    toastFlashMessage('Security Deposit Currency Details Updated Successfully', 'success');
                    window.location.reload()
                } else {
                    setLoading(false);
                    toastFlashMessage('Error Occured while updating Security Deposit Currency Details', 'error');
                }
            }
            )
    }
    return (
        <>
            <div className="data-invoice-block" style={{ marginBottom: '16px', height: '55px' }}>
                {checkPermission('contracts', 'security_deposit', 'U') ?
                    <h5 className="para">
                        <Tooltip title="Edit Security Currency Details" placement="top">
                            <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" className="editIcon" src={editIconWhite} alt="img" />
                        </Tooltip>
                    </h5> : null}
                <Row>
                    <InvoiceConfigCol
                        size="2"
                        title="Base Amount Currency"
                        value={securityCurrencycard?.titan_extra_fields?.base_currency || '--'}
                    />
                    <InvoiceConfigCol
                        size="4"
                        title="Contractual Amount Currency"
                        value={securityCurrencycard?.titan_extra_fields?.contractual_currency || '--'}
                    />
                </Row>
            </div>
            {editModal.modal ?
                <EditSidebar
                    title={`Edit Security Currency Details`}
                    editSideBar={editModal?.modal}
                    toggleEditSideBar={() => setEditModal({ modal: false })}
                >
                    <EditSecurityCurrencyCard
                        type="edit"
                        securityCurrencycard={securityCurrencycard}
                        toggleEditSideBar={() => setEditModal({ modal: false })}
                        updateSecurityCurrencycard={(data) => updateSecurityCurrencycard(data,)}
                    />
                </EditSidebar> : null}
            {isLoading ? <PageLoader /> : null}
        </>
    )
}